import React, { useState, memo, useEffect } from "react";
import { DebounceInput } from "react-debounce-input";
import { DialogMain, IconButtonMain } from "../accounting/styles/DialogStyles";
import { DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DebounceInputMain, UsersList } from "./styles/SearchStyles";
// import { UserAvatar } from "./styles/UserBoxStyles";
// import admin_login from "../../../assets/images/admin_login.png";
import CustomScrollbar from "../../shared/CustomScrollbar";
import { SearchUser } from "../../../services/admin/chat";
import { UpdatedSelectedUser } from "../../../redux/slice/admin/chat/ChatSlice";
import { useDispatch } from "react-redux";

const UsersPopup = ({ open, handleClose = () => {}, UserType = "" }) => {
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [UserArray, setUserArray] = useState([]);
  const [AllUserArray, setAllUserArray] = useState([]);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    if (UserType && open) {
      SearchUserApi();
    }
  }, [open]);

  const SearchUserApi = async () => {
    const SetType =
      UserType === "CUSTOMER"
        ? "customers"
        : UserType === "DRIVER"
        ? "drivers"
        : "customers";
    const res = await SearchUser(setLoading, SetType);
    if (res.status === 200) {
      setUserArray(res?.data?.data);
      setAllUserArray(res?.data?.data);
    }
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query === "") {
      // Reset to original unfiltered array
      setUserArray(AllUserArray);
    } else {
      const filteredUsers = UserArray?.filter((user) =>
        user.name.toLowerCase().includes(query.toLowerCase())
      );
      setUserArray(filteredUsers);
    }
  };

  const SelectedUser = (value) => {
    const changeValue = {
      user_slug: value.slug,
      user_name: value.name,
      user_image: null,
    };
    dispatch(UpdatedSelectedUser(changeValue));
    handleClose();
  };

  return (
    <>
      <DialogMain open={open} onClose={handleClose}>
        <DialogTitle>
          <div className="headerMain">
            <div className="title">
              <h6 style={{ fontWeight: "bold" }}>Select Users</h6>
            </div>
            <div className="closeBtn">
              <IconButtonMain onClick={handleClose}>
                <CloseIcon />
              </IconButtonMain>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DebounceInputMain>
            <DebounceInput
              debounceTimeout={300}
              onChange={handleSearch}
              value={searchQuery}
              placeholder="Search..."
            />
          </DebounceInputMain>
          <CustomScrollbar height="200px">
            {Loading && "Loading..."}
            <UsersList>
              <>
                {!Loading && UserArray && UserArray?.length !== 0
                  ? UserArray.map((user, index) => (
                      <div
                        key={index + "__" + user.slug}
                        className="UserList"
                        onClick={() => SelectedUser(user)}
                      >
                        {/* <UserAvatar alt="userimage" src={admin_login} /> */}
                        {user.name}
                      </div>
                    ))
                  : !Loading && "User Not Found!"}
              </>
            </UsersList>
          </CustomScrollbar>
        </DialogContent>
      </DialogMain>
    </>
  );
};

export default memo(UsersPopup);
